module.exports = __webpack_public_path__ + "img/location_example_en.8d60aeb2.jpg";